setTimeout(() => {
    const productForm = document.querySelector("[bss-b2b-main-product-form]");
    BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {productForm});
},700)


document.addEventListener("click", function (e) {
    if (e.target.closest(".quick-add__submit")) {
        setInterval(() => {
            document.dispatchEvent(new Event("bss_b2b:QuickviewLoaded"));            
        }, 2000);
    }
});

let tried = 0;
const MAX_TRY = 50; 

// const interval = setInterval(() => {
//     const bss = window.BSS_B2B;
//     const rule = bss?.nt?.appliedRule;
//     const customerId = bss?.shopData?.customer_id;

//     if (rule?.customer_ids && customerId) {
//         if (rule.customer_ids.includes(customerId)) {
//             const nt = document.querySelector("#bss-b2b-net-term-button-wrapper");
//             if (nt) {
//                 nt.style.display = "none";
//             }
//         }
//         clearInterval(interval);y
//         return;
//     }

//     tried++;
//     if (tried >= MAX_TRY) {
//         clearInterval(interval); 
//     }
// }, 100);
